import { createSlice } from "@reduxjs/toolkit"


const pedagogicalRecoverySlice = createSlice({
  name: "teacher/pedagogicalRecovery",
  initialState: {
    test: "test",
    students: [],
    isLoading: false,
    selectedRow: null,
    isEditing: false,
    isSaveConfirmationModal: false,
    unsavedData: null,
    visibleColumns: [],
    periodsOptions: [],
    period: null,
    isLoadingPeriods: false,
    filterby: "",
  },
  reducers: {
    onReadPeriod: state => {
      state.isLoadingPeriods = true
    },
    onReadPeriodSuccess: (state, action) => {
      state.periodsOptions = action.payload.periodsOptions
      state.isLoadingPeriods = false
    },
    setCurrentPeriod: (state, action) => {
      state.period = action.payload
    },
    onReadData: state => {
      state.isLoading = true
      state.filterby = ""
    },
    onReadDataSuccess: (state, action) => {
      state.isLoading = false
      state.students = action.payload
    },
    onFilterChange: (state, action) => {
      state.filterby = action.payload
    },
  },
})



export const {
  setCurrentPeriod,
  onReadPeriod,
  onReadPeriodSuccess,
  onReadData,
  onReadDataSuccess,

  onFilterChange,
  onEditStart,
  onEdit,
  onSaveConfirmationModalStart,
  onSaveConfirmationCancel,
  onToggleColumnVisibility,
} = pedagogicalRecoverySlice.actions
export default pedagogicalRecoverySlice.reducer



